export const checkFlightRecencyWarningsPIC = (pic, flight) => {
  const { recency = {} } = pic || {};

  if (!recency) return false;
  const isNotValid =
    recency.spl === "invalid" ||
    recency.medical ||
    recency.starts < 15 ||
    recency.vliegduur < 300 ||
    recency.checks < 2 ||
    (recency.lieraantekening === "invalid" && flight.start_methode == "lier") ||
    (recency.sleepaantekening === "invalid" &&
      flight.start_methode == "sleep") ||
    (recency.zelfstartaantekening === "invalid" &&
      flight.start_methode == "zelf") ||
    (recency.tmgaantekening === "invalid" && flight.start_methode == "tmg") ||
    (recency["tmg-a-aantekening"] === "invalid" &&
      flight.start_methode == "tmg-a") ||
    (recency.bungeeaantekening === "invalid" &&
      flight.start_methode == "bungee") ||
    (recency.caraantekening === "invalid" && flight.start_methode == "car") ||

    // check pax as well, if there is a pax
    (flight.tweede_inzittende_id && checkFlightPaxValidity(pic));

  return isNotValid;
};

export const checkFlightPaxValidity = (pic) => {
  const { recency = {} } = pic || {};

  if (!recency) return false;

  const isInstructor = pic?.tag === "instructeur" || pic?.tag === "basic_instructor";

  // instructors can bypass passagiervliegen if both bis and fis are valid
  const instructorCanCircumvent = isInstructor && recency.bis !== "invalid" && recency.fis !== "invalid";

  const isNotValid = recency.passagiervliegen === "invalid" && !instructorCanCircumvent;

  return isNotValid;
};
